import { message } from 'ant-design-vue'
import store from '../store'

export default function (url, method, data, contentType,filename,callback) {
  function Utf8ArrayToStr(array) {
    let out, i, len, c
    let char2, char3
    out = ''
    len = array.length
    i = 0
    while (i < len) {
      c = array[i++]
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          out += String.fromCharCode(c)
          break
        case 12:
        case 13:
          char2 = array[i++]
          out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f))
          break
        case 14:
          char2 = array[i++]
          char3 = array[i++]
          out += String.fromCharCode(
            ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0),
          )
          break
      }
    }
    return out
  }

  if (method == null) {
    method = 'post'
  }

  let token = localStorage.getItem('token')
  // let companyId = store.state.companyId;
  // let stationId = store.state.parkInfo;
  let newStationInfo = JSON.parse(localStorage.getItem('newStationInfo')) || ''
  window.addEventListener('setItem', (e) => {
    let newVal = JSON.parse(e.newValue)
    newStationInfo = newVal
  })

  let xhr = new XMLHttpRequest()
  xhr.open(method, url, true)
  xhr.setRequestHeader('Authorization', token)
  xhr.setRequestHeader('companyId', newStationInfo.parentId || null)
  xhr.setRequestHeader('stationId', newStationInfo.parkId || null)
  if (contentType) {
    xhr.setRequestHeader('Content-Type', contentType)
  }
  xhr.responseType = 'arraybuffer'
  xhr.onload = function (rep) {
    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
      let contentType = xhr.getResponseHeader('Content-Type')
      if (contentType.toLowerCase().indexOf('application/json') != -1) {
        let text = Utf8ArrayToStr(new Uint8Array(xhr.response))
        message.error(JSON.parse(text).message)
        if (callback) {
          callback(false)
        }
        return
      }
      // let filename = xhr.getResponseHeader('Content-disposition')
      // filename = filename.substring(
      //   filename.indexOf('filename=') + 'filename='.length,
      // )
      // filename = decodeURIComponent(filename)
      // filename = filename.replace(/"/g, '')
      //  filename = new Date().valueOf() +'台账'
      let content = xhr.response
      let blob = new Blob([content])
      if (callback) {
        callback(true)
      }
      if ('msSaveOrOpenBlob' in navigator) {
        window.navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        let elink = document.createElement('a')
        elink.download = filename+'.xlsx'
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
    } else {
      if (callback) {
        callback(false)
      }
      message.error('导出失败')
    }
  }
  xhr.onerror = function (evt) {
    if (callback) {
      callback(false)
    }
    message.error('导出失败')
  }
  xhr.send(data)
}
